export default __webpack_public_path__ + "static/media/50.b134cf29.svg";